var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMbLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 30,
    viewBox: "0 0 209 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M195.401 30H188.515L194.886 6.1192H189.781L191.404 0H208.5L206.877 6.1192H201.733L195.401 30Z",
    fill: "#FBC915"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M172.695 0H189.752L188.129 6.15894H177.879L176.336 11.9205H183.182L181.56 18.0795H174.714L173.17 23.8808H183.38L181.758 30H164.662L172.695 0Z",
    fill: "#FBC915"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M166.224 0C168.084 0 169.232 1.54967 168.717 3.45695C168.005 6.15894 167.253 8.86093 166.541 11.5629C166.026 13.4702 164.087 15.0199 162.188 15.0199C164.087 15.0199 165.235 16.5298 164.72 18.4371C164.008 21.1391 163.256 23.8411 162.544 26.543C162.029 28.4503 160.09 30 158.191 30C153.64 30 149.089 30 144.538 30C147.229 19.9868 149.88 10.0132 152.571 0C157.122 0 161.673 0 166.224 0ZM157.676 19.1523C157.835 18.5563 157.478 18.0795 156.885 18.0795H154.589L153.046 23.8808H155.341C155.935 23.8808 156.568 23.3642 156.726 22.7682L157.676 19.1523ZM160.842 7.23179C161 6.63576 160.644 6.15894 160.051 6.15894H157.755L156.212 11.9205H158.507C159.101 11.9205 159.734 11.4437 159.892 10.8477L160.842 7.23179Z",
    fill: "#FBC915"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M134.869 15.0199L133.721 0H140.568L140.963 4.96689L143.971 0H150.817L141.715 15.0199L137.718 30H130.832L134.869 15.0199Z",
    fill: "url(#paint0_linear_3848_31963)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.875 0C130.735 0 131.882 1.54967 131.368 3.45695C130.655 6.15894 129.903 8.86093 129.191 11.5629C128.677 13.4702 126.738 15.0199 124.838 15.0199C126.738 15.0199 127.885 16.5298 127.371 18.4371L124.284 30H117.438L120.326 19.1523C120.485 18.5563 120.129 18.0795 119.535 18.0795H117.24C116.171 22.053 115.103 26.0265 114.074 30H107.188C109.879 19.9868 112.53 10.0132 115.221 0C119.772 0 124.323 0 128.875 0ZM123.492 7.23179C123.651 6.63576 123.295 6.15894 122.701 6.15894H120.406L118.862 11.9205H121.158C121.751 11.9205 122.384 11.4437 122.543 10.8477L123.492 7.23179Z",
    fill: "url(#paint1_linear_3848_31963)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4838 0H112.54L110.918 6.15894H100.668L99.1246 11.9205H105.971L104.348 18.0795H97.5021L95.9587 23.8808H106.169L104.546 30H87.4503L95.4838 0Z",
    fill: "url(#paint2_linear_3848_31963)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1009 30H72.215L78.5864 6.1192H73.4813L75.1039 0H92.1999L90.5774 6.1192H85.4327L79.1009 30Z",
    fill: "url(#paint3_linear_3848_31963)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1248 14.6225C53.1141 10.8874 54.1035 7.19205 55.0928 3.45695C55.6073 1.54967 57.5464 0 59.446 0H69.6561C71.5557 0 72.6637 1.54967 72.1889 3.45695C71.6744 5.3245 71.1995 7.19205 70.685 9.01987H63.8387L64.3136 7.23179C64.4719 6.63576 64.1157 6.15894 63.5221 6.15894H62.3349C61.7413 6.15894 61.1081 6.63576 60.9498 7.23179L59.9604 10.8477C59.8021 11.4437 60.1979 11.9205 60.7915 11.9205H66.4902C68.3897 11.9205 69.4978 13.4702 68.9834 15.3775C67.994 19.1126 67.0046 22.8079 66.0153 26.543C65.5008 28.4503 63.5617 30 61.6621 30H51.452C49.5524 30 48.4444 28.4503 48.9588 26.543C49.4337 24.6755 49.9482 22.8079 50.4231 20.9801H57.2694L56.7945 22.7682C56.6362 23.3642 56.9924 23.8808 57.586 23.8808H58.7732C59.4064 23.8808 60 23.3642 60.1583 22.7682L61.1477 19.1523C61.306 18.5563 60.9498 18.0795 60.3562 18.0795H54.6179C52.7579 18.0795 51.6103 16.5298 52.1248 14.6225Z",
    fill: "url(#paint4_linear_3848_31963)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5382 15.0199L37.3906 0H44.2369L44.6326 4.96689L47.6403 0H54.4866L45.3845 15.0199L41.3876 30H34.5016L38.5382 15.0199Z",
    fill: "url(#paint5_linear_3848_31963)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9538 0H35.8002L27.8062 30H20.9598L23.6113 20.0662L17.596 30H10.7497L9.9978 20.0662L7.38591 30H0.5L8.53356 0H15.3799L16.8441 19.947L28.9538 0Z",
    fill: "url(#paint6_linear_3848_31963)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3848_31963",
    x1: 140.825,
    y1: 0,
    x2: 140.825,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3848_31963",
    x1: 119.339,
    y1: 0,
    x2: 119.339,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3848_31963",
    x1: 99.9953,
    y1: 0,
    x2: 99.9953,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3848_31963",
    x1: 82.2074,
    y1: 0,
    x2: 82.2074,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3848_31963",
    x1: 60.5657,
    y1: 0,
    x2: 60.5657,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3848_31963",
    x1: 44.4941,
    y1: 0,
    x2: 44.4941,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3848_31963",
    x1: 18.1501,
    y1: 0,
    x2: 18.1501,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMbLogo);
export default ForwardRef;